import React from 'react';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';
import classNames from 'classnames';

import './BetCombinations.scss';
import { Stake } from '../../../../interfaces/BetslipState';
import { formatAmountToFixed } from 'src/utils/utils';

interface BetCombinationsProp {
  item: {
    stakes: {
      combinations: Stake[]
    }
  },
  betslip: boolean,
  myBets?: boolean
}

export default function BetCombinations({ item, betslip, myBets=false }: BetCombinationsProp) {
  const { t } = useTranslation();

  return (
    <div className={
      classNames({
        'bet-combinations': true,
        'bet-combinations--my-bets': myBets
      })
    }
    >
      <h2 className={
        classNames({
          'bet-combinations__header': true,
          'bet-combinations__header-slip': betslip
        }
        )
      }
      >
        { t('betHistory.betsOnTicket') }
      </h2>
      <div className="bet-combinations__body">
        <div className={
          classNames({
            'bet-combinations__row': !betslip,
            'bet-combinations__row-slip': betslip
          })
        }
        >
          <div className="bet-combinations__title-bets">{ t('betHistory.bets') }</div>
          <div className="bet-combinations__title">{ t('betHistory.stake') }</div>
          <div className="bet-combinations__title">{ t('betHistory.odds') }</div>
          <div className="bet-combinations__title">{ betslip ? t('betHistory.potencialReturnCaps') : t('betHistory.potencialReturn') }</div>
        </div>
        {
          _.map(item.stakes.combinations, (combination, index) => {
            const returnValue = combination.return || combination.maximumReturn;

            return (
              <div
                key={ combination.stake + combination.odds + index }
                className={
                  classNames({
                    'bet-combinations__row': !betslip,
                    'bet-combinations__row-slip': betslip
                  })
                }
              >
                <div
                  className="bet-combinations__highlighted"
                >
                  { combination.lines.join(', ') }
                </div>
                <div className="bet-combinations__value">{ formatAmountToFixed(combination.stake) }</div>
                <div className="bet-combinations__value">{ combination.odds }</div>
                <div className="bet-combinations__value">{ formatAmountToFixed(returnValue) }</div>
              </div>
            );
          })
        }
      </div>
    </div>
  );
}
